module.exports = __webpack_public_path__ + "static/media/mbennasar3.167e48e3.jpg";